import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function BarCocktail(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M19.09 2.707a.75.75 0 00-.498-1.414l-2.841 1a.75.75 0 00-.479.525L14.477 6H10.75A4.75 4.75 0 106 10.75c.317 0 .857-.052 1.406-.209L11 15.333V20h-1a1 1 0 100 2h4a1 1 0 000-2h-1v-4.667L18.8 7.6A1 1 0 0018 6h-1.977l.607-2.427 2.46-.866zM6 2.75a3.25 3.25 0 000 6.5c.095 0 .241-.009.414-.032L5.2 7.6A1 1 0 016 6h3.25A3.25 3.25 0 006 2.75zm3.137 6.645a1.941 1.941 0 01-.042.065L12 13.333 16 8H8l.967 1.29.17.105z",
    clipRule: "evenodd"
  }));
}

export default BarCocktail;